import React from 'react';
export function Logo({
  className = '',
  dark = false
}: {
  className?: string;
  dark?: boolean;
}) {
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-163">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-164">
        {/* Angled link shape */}
        <g transform="translate(20, 24) rotate(-35) translate(-20, -24)" data-id="element-165">
          <rect x="8" y="14" width="24" height="20" rx="10" fill="#006DFF" data-id="element-166" />
          <rect x="13" y="19" width="14" height="10" rx="5" fill="white" data-id="element-167" />
        </g>
        {/* Graduation Cap */}
        <path d="M20 4L32 10L20 16L8 10L20 4Z" fill="#006DFF" data-id="element-168" />
        <path d="M12 12V18C12 18 16 22 20 22C24 22 28 18 28 18V12" fill="#003B8F" data-id="element-169" />
      </svg>
      <div className="flex flex-col leading-none justify-center" data-id="element-170">
        <span className={`text-xl font-bold tracking-tight ${dark ? 'text-white' : 'text-link-navy'}`} data-id="element-171">
          LINK
        </span>
        <span className={`text-lg font-semibold tracking-tight ${dark ? 'text-white' : 'text-link-blue'}`} data-id="element-172">
          Academy
        </span>
      </div>
    </div>;
}